import { render } from "./AdminPortal.vue?vue&type=template&id=468c2b5c&ts=true"
import script from "./AdminPortal.vue?vue&type=script&lang=ts"
export * from "./AdminPortal.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__